import styled, { css } from 'styled-components';
import theme from 'styles/theme';

import XCircleFillIcon from 'assets/images/icons/x-circle-fill.svg?react';
import ArrowCounterClockwiseIcon from 'assets/images/icons/arrow-counterclockwise.svg?react';
import PencilSquareIcon from 'assets/images/icons/pencil-square.svg?react';

export const XCircleFillIconStyled = styled(XCircleFillIcon)`
  color: ${theme.colors.hostfullyBlue};
`;

export const ArrowCounterClockwiseIconStyled = styled(
  ArrowCounterClockwiseIcon,
)`
  color: ${theme.colors.hostfullyBlue};
`;

export const PencilSquareIconStyled = styled(PencilSquareIcon)`
  color: ${theme.colors.hostfullyBlue};
`;

export const ActionsCellContainer = styled.div<{ $isRetrying: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 8px;

  ${({ $isRetrying }) =>
    $isRetrying &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
      pointer-events: none;
      filter: grayscale(100%);

      svg {
        // animate with a rotation
        animation: rotate 1s linear infinite;
        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(-360deg);
          }
        }
      }
    `}
`;
